import { render, staticRenderFns } from "./ModelList.vue?vue&type=template&id=dfdc74d6&"
import script from "./ModelList.vue?vue&type=script&lang=ts&"
export * from "./ModelList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports